import { render, staticRenderFns } from "./ProductPerformance.vue?vue&type=template&id=35f58c7e&scoped=true"
import script from "./ProductPerformance.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPerformance.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductPerformance.vue?vue&type=style&index=0&id=35f58c7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f58c7e",
  null
  
)

export default component.exports